import React from 'react';
import SarasListItem from '../../../library/repeater/list/SarasListItem';
// import Icon from '../../../library/decor/SarasIcons';

const SarasFilterMenuItem = ({menuRow, onClick}) => {
  
  function handleParentClick(e) {
    if(onClick){
      onClick(menuRow);
    }
  }

  // const MIcon = Icon[menuRow.MenuIcon];

  // console.log("filter menu row item", menuRow, menuRow.dataList.label);

  return (
    <SarasListItem 
      onclick={handleParentClick} 
      listItemClass={'uiLink'}
      text={menuRow.dataList.label} >
    </SarasListItem>
  )
}

export default SarasFilterMenuItem;
